import { Component, Input, OnInit, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Subscription,Observable } from 'rxjs';

import { ProjectsFormsService} from '@app/services/app/projects-forms.service';
import * as Objects from '@core/objects';

@Component({
    selector: 'project-details-forms-list',
    templateUrl: './list.component.html',
    styleUrls: ['./list.component.scss']
})
export class ProjectDetailsFormsListComponent implements OnInit, OnDestroy{
    public readonly ACCESS_FORMS = "access_request_forms";

	@Input() project: Objects.Request = null;
    @Input() user: Objects.User = null;
    
    /**
     * - The async pipe automatically subscribes to an 
     *      Observable or Promise and returns the latest value it has emitted.
     * - When the component is destroyed, the async pipe unsubscribes 
     *      from the Observable automatically, preventing memory leaks.
     * - It allows you to bind the emitted values directly in the template 
     *      without manually subscribing in the component class.
     * Get it simple:
     * - It eliminates the need to manually subscribe and manage subscriptions 
     *      in the component class, reducing boilerplate code.
     * - Directly binding Observable data streams to the template 
     *      simplifies the logic and enhances readability.
     * - Automatically handles unsubscription, preventing potential memory leaks.
     */
    forms$: Observable<Objects.CustomFormSubmission[]>;
    loading$: Observable<boolean>;
    error$: Observable<HttpErrorResponse>;

    // Track expandable forms state by form id
    protected expandableForms: Map<string, boolean> = new Map();  

    protected subscriptor: Subscription;
    protected accessSubscriptor: Subscription;

    
    public prefixUrl: string = "";
    public openedFormIds: Array<string> = [];
    public leavingModal: boolean = false;
    public togglingForm: string; 
    // todo setup the id of form toggling to after click on modal cancel toggle action or discard values and toggle
     
	constructor(
        private projectFormsSrv: ProjectsFormsService
    ){
        this.forms$ = this.projectFormsSrv.selectForms();
        this.loading$ = this.projectFormsSrv.selectLoadingForms();
        this.error$ = this.projectFormsSrv.selectErrorForms();
    }

    ngOnInit() {
    }

    ngOnChanges(changes: SimpleChanges) {
        if(changes.project) 
            this.prefixUrl = "/requests/" + this.project.id;
    }

    ngOnDestroy() {
    }

    initView() : void {
    }

    public onCanCollapse(formUuid: string, canCollapse: boolean): void {
        // Update the collapsible state for the form in the map
        this.expandableForms.set(formUuid, canCollapse);
    }

    public onToggle(form: Objects.CustomFormSubmission) : void{
        this.togglingForm = form.uuid;
        const isCollapsable = this.expandableForms.get(form.uuid);

        // If the form is not collapsible, prevent the action
        if (isCollapsable === false) {
            console.log(`Form ${form.name} is not collapsable`);
            this.leavingModal = true;
            return;
        }
        const index = this.openedFormIds.indexOf(form.uuid);
        if (index > -1) {
            // If form ID is in the list, remove it
            this.openedFormIds.splice(index, 1);
        } else {
            // If form ID is not in the list, add it
            this.openedFormIds.push(form.uuid);
        }
    }

    public onLeave() {
        if(this.togglingForm && this.togglingForm != ''){
            const index = this.openedFormIds.indexOf(this.togglingForm);
            if (index > -1) {
                // If form ID is in the list, remove it so became closed
                this.openedFormIds.splice(index, 1);
            }
        }
        this.togglingForm = '';
        this.leavingModal = false;
    }

    onStay(){
        this.togglingForm = '';
        this.leavingModal = false;
    }

    public isOpen(form: Objects.CustomFormSubmission): boolean {
        return this.openedFormIds.includes(form.uuid);
    }

    onCancel(form: Objects.CustomFormSubmission) : void {
        this.onToggle(form);
    }
 

}
